import React, { useState, useEffect } from 'react';
import Icon from '../../../Components/Icons/Icon';
import { Link } from 'react-router-dom';
import { useUnreadThreads } from '../../../Data/Messages';
import { useLiveUnreadThreads } from '../../../Data/Local/Message/hooks';
import { useDataSource, resolveSource } from '../../../Data/Local/dataSource';
import messageFeed from '../../../Data/Local/Message/feed';

const Inbox = () => {
    const source = useDataSource(messageFeed.name);
    const api = useUnreadThreads(source.isLocal);
    const local = useLiveUnreadThreads(source.isLocal);
    const {data: unread} = resolveSource(source, {local: local?.unread, api: api.unread});
    const [unreadCount, setUnreadCount] = useState(0);

    useEffect(() => {
        setUnreadCount(unread?.length ?? 0);
    }, [unread]);

    return <Link to="/messages" className="contents">
        <Icon icon="Message"
            size="2x"
            badge={unreadCount ? true : null}
        />
    </Link>;
};

export default Inbox;
